const TouristContacts = () => import('@/views/tourist/contacts/Contacts')
const ContactsCountry = () => import('@/views/tourist/contacts/ContactsCountry')
const ListTourists = () => import('@/views/tourist/prospect/ListTourists')
const ContactsFeedback = () => import('@/views/tourist/contacts/ContactsFeedback')

const mainWidget = [
  {
    title: 'จำนวนครั้งของการติดต่อ ททท. ผ่านช่องทางต่างๆ',
    path: '/admin/widget/:category/:widget_code(12)',
    component: TouristContacts
  },
  {
    title: 'แผนที่แสดงปริมาณการติดต่อ (ททท.) ในแต่ละพื้นที่',
    path: '/admin/widget/:category/:widget_code(15)',
    component: ContactsCountry
  },
    {
    title: 'ประเด็นคำถามจากนักท่องเที่ยวที่สอบถามข้อมูลข่าวสารจาก ททท.',
    path: '/admin/widget/:category/:widget_code(17)',
    component: ListTourists
  },
    {
    title: 'รายการข้อความ ที่ติดต่อ ททท. ผ่านช่องทางต่างๆ แยกตาม Sentiment',
    path: '/admin/widget/:category/:widget_code(13)',
    component: ContactsFeedback
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})